<!-- <div class="container mt-5 row" *ngIf="hasData | async"> -->
<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }

  <div class="sidebar">
    <div #projectTypeDrop ngbDropdown class="input-group mb-3">
      <button ngbDropdownToggle [disabled]="this.isWorking || this.helpers.getJobIsLocked(this.job)"
      class="btn lhbtn btn-primary" type="button" data-bs-toggle="dropdown">{{selectedAnalysis.description}}</button>
      <div ngbDropdownMenu>
        @for (analysis of this.analysisMap; track analysis) {
          <button class="dropdown-item" (click)="updateAnalysisType(analysis);">{{analysis.description}}</button>
        }
      </div>
      @if (this.job) {
        <input [(ngModel)]="this.job.title" [disabled]="this.helpers.getJobIsLocked(this.job)"
          (change)="this.isDirty = true" type="text" class="form-control" placeholder="Job title">
        <a class="jsonlink" [hidden]="!this.job" routerLink="/job/{{this.job.id}}"></a>
      }
    </div>

    <mat-accordion multi>

      @for (item of [1]; track item; let isFirst = $first) {
        <mat-expansion-panel [expanded]="isFirst">
          <mat-expansion-panel-header class="header">
            <mat-panel-title>
              <label class="headertitle">Simulation{{this.isDirty ? "*" : ""}}</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (field of this.job?.string_data; track field; let i = $index) {
            <div>
              <div class="field">
                <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" [(ngModel)]="field.value"
                  (change)="this.updateGeometries()" />
              </div>
            </div>
          }
          @for (field of this.job?.data; track field; let i = $index) {
            <div>
              @if (field.section == 'simulation') {
                <div class="field">
                  <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                  <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                    [(ngModel)]="field.value.magnitude[0]" (change)="this.updateGeometries()" />
                  <label class="fieldunit">{{field.value.unit_string ? field.value.unit_string :
                  ""}}</label>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }

      <mat-expansion-panel>
        <mat-expansion-panel-header class="header">
          <mat-panel-title>
            <label class="headertitle">Operating Points</label>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @for (field of this.job?.data; track field; let i = $index) {
          <div>
            @if (field.section == 'operating_point') {
              <div class="field">
                <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                  [(ngModel)]="field.value.magnitude[0]" (change)="this.updateGeometries()" />
                <label class="fieldunit">{{field.value.unit_string ? field.value.unit_string :
                ""}}</label>
              </div>
            }
          </div>
        }
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header class="header">
          <mat-panel-title>
            <label class="headertitle">Windings</label>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @for (field of this.job?.data; track field; let i = $index) {
          <div>
            @if (field.section == 'winding') {
              <div class="field">
                <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                  [(ngModel)]="field.value.magnitude[0]" (change)="this.updateGeometries()" />
                <label class="fieldunit">{{field.value.unit_string ? field.value.unit_string :
                ""}}</label>
              </div>
            }
          </div>
        }
      </mat-expansion-panel>

      @if (selectedAnalysis.doRotor) {
        <mat-expansion-panel>
          <mat-expansion-panel-header class="header">
            <mat-panel-title>
              <label class="headertitle">Rotor</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div #rotorTypeDrop ngbDropdown class=" ">
            <button ngbDropdownToggle [disabled]="this.helpers.getJobIsLocked(this.job)"
              class="fieldvalue ddpartfieldvalue ddheaderfieldvalue" type="button"
            data-bs-toggle="dropdown">{{activeRotorType.description}}</button>
            <div ngbDropdownMenu>
              @for (rotorType of rotorTypesMap; track rotorType) {
                <button class="dropdown-item" (click)="this.updateRotorType(rotorType)">{{rotorType.description}}</button>
              }
            </div>
          </div>
          @for (field of this.job?.data; track field; let i = $index) {
            <div>
              @if (field.section == 'rotor') {
                <div class="field">
                  <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                  <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                    [step]="field.name === 'number_poles' ? 2 : 1" [(ngModel)]="field.value.magnitude[0]"
                    (change)="this.updateGeometries()" />
                  <label class="fieldunit">{{field.value.unit_string ? field.value.unit_string :
                  ""}}</label>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }

      @if (selectedAnalysis.doStator) {
        <mat-expansion-panel>
          <mat-expansion-panel-header class="header">
            <mat-panel-title>
              <label class="headertitle">Stator</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div #statorTypeDrop ngbDropdown class=" ">
            <button ngbDropdownToggle [disabled]="this.helpers.getJobIsLocked(this.job)"
              class="fieldvalue ddpartfieldvalue ddheaderfieldvalue" type="button"
            data-bs-toggle="dropdown">{{activeStatorType.description}}</button>
            <div ngbDropdownMenu>
              @for (statorType of statorTypesMap; track statorType) {
                <button class="dropdown-item"
                (click)="this.updateStatorType(statorType)">{{statorType.description}}</button>
              }
            </div>
          </div>
          @for (field of this.job?.data; track field; let i = $index) {
            <div>
              @if (field.section == 'stator') {
                <div class="field">
                  <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                  <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                    [(ngModel)]="field.value.magnitude[0]" (change)="this.updateGeometries()" />
                  <label class="fieldunit">{{field.value.unit_string ? field.value.unit_string :
                  ""}}</label>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }

      @if (this.job?.status > 0) {
        <mat-expansion-panel>
          <mat-expansion-panel-header class="header">
            <mat-panel-title>
              <label class="headertitle">Results</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (field of this.job?.data; track field; let i = $index) {
            <div>
              @if (field.section == 'calculated_results') {
                <div class="field">
                  <label class="fieldname">{{this.helpers.snake2Pascal(field.name)}}</label>
                  <input [disabled]="this.helpers.getJobIsLocked(this.job)" class="fieldvalue" type="number"
                    [(ngModel)]="field.value.magnitude[0]" />
                  <label class="fieldunit">{{field.value.unit_string }}</label>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>


  <div class="actions">

    <span
      [ngClass]="(!this.isDirty && this.helpers.getJobIsExisting(this.job) && this.job?.status == 0 && selectedAnalysis.name == 'electromagnetic' && !this.helpers.getJobIsLocked(this.job)) ? 'onqueue_actions' : ''">
      @if (!this.job?.is_deleted && !this.isDirty && this.helpers.getJobIsExisting(this.job) && this.job?.status == 0 &&
        selectedAnalysis.name == 'electromagnetic') {
        <span>
          <label>Also run: &nbsp;</label>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="at_mech" [(ngModel)]="this.doMechanical">
            <label class="form-check-label" for="at_mech">Mechanical</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="at_therm" [(ngModel)]="this.doThermal"
              (change)="toggleAnalysisType()">
            <label class="form-check-label" for="at_therm">Thermal</label>
          </div>
        </span>
      }
      @if (!this.isDirty && this.helpers.getJobIsExisting(this.job) && !this.helpers.getJobIsLocked(this.job)) {
        <div class="action">
          <button [disabled]="this.isWorking" class="btn btn-primary" type="button" (click)="queueJob()">Queue</button>
        </div>
      }
    </span>

    @if (this.isDirty && !this.helpers.getJobIsLocked(this.job)) {
      <div class="action">
        <button [disabled]="this.isWorking" class="btn btn-primary" type="button"
        (click)="createOrUpdateJob()">Save</button>
      </div>
    }

    @if (!this.job?.is_deleted && !this.isDirty && this.helpers.getJobIsExisting(this.job)) {
      <div class="action">
        <button [disabled]="this.isWorking" class="btn btn-primary" type="button" (click)="copyJob()">Copy</button>
      </div>
    }
    @if (this.job?.is_deleted) {
      <div class="action">
        <button class="btn btn-primary" type="button" (click)="deleteJob(this.job.id, 20)">Restore</button>
      </div>
    }
    @if ([0, 10, 70, 80].includes($safeNavigationMigration(this.job?.status)) && !this.helpers.getJobIsLocked(this.job)) {
      <div class="action">
        <button [disabled]="this.isWorking" class="btn btn-primary" type="button"
        (click)="deleteJob(this.job.id, 0)">Delete</button>
      </div>
    }
    @if (activeTab == '3' && this.job?.status == 0 && !this.helpers.getJobIsLocked(this.job)) {
      <div class="action">
        <button [disabled]="this.isWorking" class="btn btn-primary btn-context" type="button"
        (click)="resetNetlist(this.job.id)">Reset netlist</button>
      </div>
    }
    <label class="headerlabel">{{this.helpers.getJobStatusString($safeNavigationMigration(this.job?.status))}}</label>
  </div>

  <div class="tabpanel">
    <nav ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" (navChange)="onNavChange($event)"
      class="nav-tabs">
      <ng-container [ngbNavItem]="1">
        <a ngbNavLink>Geometry</a>
        <ng-template ngbNavContent>
          <div class="drawing">
            <div #svgcontainer id="svgcontainer"></div>
            <div class="description">{{this.job?.type}}</div>
          </div>
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="2">
        <a ngbNavLink>Materials</a>
        <ng-template ngbNavContent>
          <div class="materials">

            @for (jm of this.job?.materials; track jm) {
              <div class="material">
                <div #airDrop ngbDropdown class="field ddfield">
                  <label class="fieldname ddmaterialname">{{this.helpers.snake2Pascal(jm.part)}}</label>
                  <button [disabled]="this.helpers.getJobIsLocked(this.job)" ngbDropdownToggle
                    class="fieldvalue ddfieldvalue" type="button"
                    data-bs-toggle="dropdown">{{this.helpers.getMaterialNameById(materials, jm.material_id
                  )}}</button>
                  <div ngbDropdownMenu>
                    @for (material of materials; track material) {
                      <button class="dropdown-item"
                      (click)="jm.material_id = material.id; this.isDirty = true;">{{material.name}}</button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="3">
        <a ngbNavLink>Netlist</a>
        <ng-template ngbNavContent>
          <div>
            <div class="netlist-json">
              <json-editor [options]="editorOptions" (change)="changeLog($event)"
              [data]="$safeNavigationMigration(this?.job.netlist)"></json-editor>
            </div>
            <div>
              <app-netlist-viewer class="netlist-viewer" [netlistData]="this.diagramNetlist"></app-netlist-viewer>
            </div>
          </div>
        </ng-template>
      </ng-container>
      @if (this.job && this.job?.status > 0) {
        <ng-container [ngbNavItem]="4">
          <a ngbNavLink>Artifacts</a>
          <ng-template ngbNavContent>
            <div class="artifacts">
              @for (artifact of this.job?.artifacts; track artifact) {
                <div class="artifact">
                  @if (artifact.url.startsWith('file')) {
                    <a (click)="promoteArtifact(artifact)" target="_blank">
                      <span>{{artifact.type.replaceAll('_', ' ')}}</span>
                      <div class="artifactImage">
                        <!-- <fa-icon class="fa-lg" [icon]="faGears"></fa-icon> -->
                      </div>
                    </a>
                  }
                  @if (artifact.url.startsWith('https') && getArtifctMimeType(artifact) == 'image') {
                    <a href="{{artifact.url}}" target="_blank">
                      <span>{{artifact.type.replaceAll('_', ' ')}}</span>
                      <div class="artifactImage">
                        <img src="{{artifact.url}}" />
                      </div>
                    </a>
                  }
                  @if (artifact.url.startsWith('https') && getArtifctMimeType(artifact) == 'text') {
                    <a href="{{artifact.url}}" target="_blank">
                      <span>{{artifact.type.replaceAll('_', ' ')}}</span>
                      <div class="artifactImage">
                        <!-- <fa-icon class="fa-lg" [icon]="faFileAlt"></fa-icon> -->
                      </div>
                    </a>
                  }
                  @if (artifact.url.startsWith('https') &&
                    (getArtifctMimeType(artifact) == 'unknown' || getArtifctMimeType(artifact) == 'application')) {
                    <a href="{{artifact.url}}" target="_blank">
                      <span>{{artifact.type.replaceAll('_', ' ')}}</span>
                      <div class="artifactImage">
                        <!-- <fa-icon class="fa-lg" [icon]="faGears"></fa-icon> -->
                      </div>
                    </a>
                  }
                </div>
              }
              @if ([70, 80].includes($safeNavigationMigration(this.job?.status)) && !this.helpers.getJobHasRollup(this.job)) {
                <div class="rollup">
                  <a (click)="rollupArtifacts()">
                    <span>Rollup</span>
                    <div class="artifactImage">
                      <!-- <fa-icon class="fa-lg" [icon]="faFileZipper"></fa-icon> -->
                    </div>
                    <div class="progress-bar">
                      <div class="progress-bar-fill" [ngStyle]="{'width.%': this.rollupProgress}">Rolling up ...</div>
                    </div>
                  </a>
                </div>
              }
            </div>
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="5">
          <a ngbNavLink>Visualisation</a>
          <ng-template ngbNavContent>
            <div class="trame">
              <iframe [src]="visUrl | safe" scrolling="no"></iframe>
            </div>
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="6">
          <a ngbNavLink>Logs</a>
          <ng-template ngbNavContent>
            <div class="logs">
              <div class="logmessages" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                @for (log of receivedLogs; track log) {
                  <span class="logmessage {{ this.helpers.getLogClass(log)}}">{{log}}</span>
                }
              </div>
              <div class="progress">
                {{solveProgress}} {{timeProgress}}
              </div>
            </div>
          </ng-template>
        </ng-container>
      }
    </nav>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>

    <!-- <pre>Active: {{ active }}</pre> -->

  </div>

</div>